import request from "../utils/request";

export const getCountries = '/country/';

export function modifyCountry(data: any) {
    return request.request({
        url: '/country/',
        method: data.id ? 'put' : 'post',
        data: data
    })
}

export function deleteCountry(id: number) {
    return request.request({
        url: '/country/',
        method: 'delete',
        params: {countryId: id}
    })
}
